import React from 'react';
import { SeparationType } from '../../enums/SeparationType';
import { OrderForListing } from '../../models/OrderForListing';
import { Pagination } from '../../common-components/Pagination/Pagination';
import { WaitingIcon } from '../../common-components/WaitingIcon/WaitingIcon';
import { Orders } from '../Orders/Orders';
import { Container } from '../ListOrders/styles';

interface IPaginatedOrderListProps {
  currentPage: number;
  currentPageSize: number;
  amountOfPages: number;
  totalAmount: number;
  ordersForListing?: OrderForListing[];
  selectAll?: () => void;
  selectOrder?: (orderId: number) => void;
  separationType: SeparationType;
  filterAreaHeight: number;
  pageSize: number;
  changePageSize: (pageSize: number) => void;
  changePage: (page: number) => void;
  filtering?: boolean;
  refreshOrder?: (orderId?: number) => void;
  expressOrder?: boolean;
}

const PaginatedOrderList: React.FC<IPaginatedOrderListProps> = ({
  currentPage,
  currentPageSize,
  amountOfPages,
  totalAmount,
  ordersForListing,
  selectAll,
  selectOrder,
  separationType,
  filterAreaHeight,
  pageSize,
  changePageSize,
  changePage,
  filtering,
  refreshOrder,
  expressOrder
}) => {

  if (filtering) return <WaitingIcon />;

  return (
    <Container>
      {ordersForListing && ordersForListing.length > 0 ?
        <Orders
          ordersForListing={ordersForListing}
          selectAllOrder={() => selectAll ? selectAll() : null}
          selectOrder={(orderId) => selectOrder ? selectOrder(orderId) : null}
          separationType={separationType}
          filterAreaHeight={filterAreaHeight}
          refreshOrder={refreshOrder}
          expressOrder={expressOrder}
        />
        : null}
      <Pagination
        currentPage={currentPage}
        currentPageSize={currentPageSize}
        amountOfPages={amountOfPages}
        totalAmount={totalAmount}
        pageSize={pageSize}
        changePageSize={(size) => changePageSize(size)}
        changePage={(page) => changePage(page)}
      />
    </Container>
  );
}

export { PaginatedOrderList };